import Styles from './QuizGridViewCard.module.scss';
import React from 'react';

// Module imports.
import { Chip, Stack, Tooltip } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';

// Components import.
import { useTranslation } from 'components/lib';

// Assets import.
const GoldIcon = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/topos-icons/global/gold_badge.png`;
const SilverIcon = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/topos-icons/global/silver_badge.png`;
const BronzeIcon = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/topos-icons/global/bronze_badge.png`;

const QuizGridViewCard = ({ tooltipMessage, ...props }) => {

	const { t } = useTranslation();
	const { data } = props;
	return (
		<div
			id="gridAncestor"
			className={Styles.container}
		// onClick={props.data.isDisabled ? null : () => props.onClick(data)}
		>
			<div className={Styles.childContainer}>
				<p className={Styles.headerText}>{data.name}</p>
				{/* image part */}
				<img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${data.icon}`} alt="courseImage" className={Styles.courseImage} />
				{/* content part */}
				<div id="contentContainer" className={Styles.contentContainer}>
					<div id="infoContainer">
						<div
							id="streamData"
							style={{
								display: 'flex',
								height: props.showInfoChips || props.showLevelChip ? '35px' : '0px',
								flexDirection: 'column',
							}}
						>
							<Stack
								direction="row"
								spacing={1}
								sx={{
									marginTop: '15px',
									marginBottom: '2px',
									height: '40px',
								}}
							>
								<Chip
									label={`${props.label_Text}: ${data.score} / ${data.totalScore !== undefined ? data.totalScore : 10}`}
									size="medium"
									sx={{
										width: '50%',
										fontWeight: 550,
										bgcolor: '#1de9b6',
										display: props.showInfoChips ? '' : 'none',
									}}
								/>
								<div
									id="medalContainer"
									className={Styles.medalContainer}
									style={{
										display: props.showMedalChips ? '' : 'none',
									}}
								>
									{/* gold = 3, silver = 2, bronze = 1 */}
									<img
										src={GoldIcon}
										title="Gold"
										alt="medal"
										width="33%"
										height="inherit"
										style={{ opacity: data.badge === 3 ? 1 : 0.2 }}
									/>
									<img
										src={SilverIcon}
										title="Silver"
										alt="medal"
										width="33%"
										height="inherit"
										style={{ opacity: data.badge === 2 ? 1 : 0.2 }}
									/>
									<img
										src={BronzeIcon}
										title="Bronze"
										alt="medal"
										width="33%"
										height="inherit"
										style={{ opacity: data.badge === 1 ? 1 : 0.2 }}
									/>
								</div>
							</Stack>
						</div>
					</div>
				</div>
				{/* submit button part */}
				<div className={Styles.buttonContainer}>
					<button
						className={Styles.startButton}
						onClick={() => props.quizClick(data)}
						style={{
							backgroundColor: props.data.isFailed ? '#FF1616' : '$c-aivagam-blue',
						}}
						variant="contained"
						disabled={props.data.isDisabled}
						color={props.data.isDisabled ? 'gray' : 'blue'}
					>
						{props.button_text}
					</button>
					<Tooltip title={t('CommonQuiz.UserQuiz.quizCard.tooltip')}>
						<span>
							<button
								className={Styles.shareButton}
								onClick={() => props.shareClick(data.id)}
								variant="contained"
								disabled={data.badge === 0}
								color={props.data.isDisabled ? 'gray' : 'blue'}
							>
								<ShareIcon />
							</button>
						</span>
					</Tooltip>
				</div>
			</div>
		</div>
	);
};

export default QuizGridViewCard;
